<script>
  export default {
    name: 'page-header',
    props: {
      autoHide: {
        type: Boolean,
        default: true
      },
      backgroundColor: {
        type: String
      },
      chipProps: {
        type: Object,
        default: () => ({})
      },
      chipItems: {
        type: Array,
        default: () => []
      },
      titleColor: {
        type: String
      },
      titleText: {
        type: String,
        default: () => ''
      },
      value: {}
    },
    data: () => ({
      chipDefaults: {
        color: 'primary'
      },
      lastScroll: 0,
      showHeader: true
    }),
    computed: {},
    methods: {
      onScroll(e) {
        if (!this.autoHide) return
        // console.log()
        const currentScroll = e?.target.scrollingElement?.scrollTop || 0
        //setup buffer?
        if (currentScroll > this.lastScroll) {
          // console.log('hide page header')
          this.showHeader = false
        }
        if (currentScroll < this.lastScroll) {
          // console.log('show page header')
          this.showHeader = true
        }
        this.lastScroll = currentScroll
      }
    },
    created() {
      console.warn('TODO: set sizing of chips on small viewport')
      // if (this.$vuetify?.breakpoint?.name === 'xs') {
      //   this.chipDefaults = { ...this.chipDefaults, small: true }
      // }
    }
  }
</script>

<template>
  <v-sheet
    v-scroll="onScroll"
    color="transparent"
    tile
    width="100%"
    class="header-sheet flex-shrink-1"
    :class="{ 'auto-hide': autoHide }"
    :style="{ top: !autoHide ? 0 : showHeader ? `${$vuetify.application.top}px` : '-500px' }"
  >
    <v-sheet :color="backgroundColor || undefined" tile width="100%" class="d-flex flex-column align-center justify-center">
      <h1 class="title-font font-weight-bold text-center mt-4 mb-8" :style="{ color: titleColor || $vuetify.theme.themes.light.primary }">{{ titleText }}</h1>
      <v-chip-group v-if="chipItems?.length" center-active show-arrows :value="value" @change="$emit('input', $event)" class="chip-group d-flex align-center justify-center pb-2">
        <v-chip
          v-for="item in chipItems"
          :key="item.key"
          v-bind="{ ...chipDefaults, ...chipProps }"
          :color="item.slug === value ? titleColor : backgroundColor"
          :outlined="item.slug !== value"
          :text-color="item.slug === value ? backgroundColor : titleColor"
          :value="item.slug"
          class="mx-2 font-weight-bold text-body-1"
        >
          <v-icon left>{{ item.icon }}</v-icon>
          <span class="ml-1">{{ item.label }}</span>
        </v-chip>
      </v-chip-group>
    </v-sheet>
    <v-sheet
      height="40px"
      width="100%"
      :color="backgroundColor || 'transparent'"
      class="fade"
      :style="{ 'mask-image': `linear-gradient(${backgroundColor}, transparent)` }"
    ></v-sheet>
  </v-sheet>
</template>

<style scoped>
  .title-font {
    font-family: 'Source Serif 4', serif !important;
    font-size: 3.75rem !important;
    font-weight: 300;
    line-height: 3.75rem;
    letter-spacing: -0.0083333333em !important;
  }

  .header-sheet {
    position: relative;
    z-index: 2;
  }
  .auto-hide {
    position: sticky;
    transition: 1s;
  }
  /* .header-sheet {
      position: sticky;
      z-index: 2;
      transition: 1s;
    } */
</style>
